module.exports = __webpack_public_path__ + "static/media/savilles.8e7ca88c.jpg";